/* eslint-disable no-undef */
import React from 'react';
import PropTypes from 'prop-types';
import AbstractButton from './AbstractButton';
import withBoundary from 'component/ErrorBoundary/withBoundary';
import { translate } from 'store/modules/base/i18n/functions';
import { connect } from 'store/modules/base/redux/functions';
import { sendMultiKnockMessage } from 'store/modules/chat/actions';
import { Knock } from 'assets/images';
import {
  registerShortcut,
  unregisterShortcut
} from 'store/modules/keyboard-shortcuts/actions';

/**
 * Implements an {@link AbstractButton} to open the user documentation in a new window.
 */
class KnockButton extends AbstractButton {
  accessibilityLabel = 'toolbar.accessibilityLabel.knock';
  icon = Knock;
  label = 'toolbar.knock';
  type = 'orange';

  // tooltip = 'toolbar.knock';

  /**
   * Initializes a new instance.
   *
   * @inheritdoc
   */
  constructor(props) {
    super(props);

    // Bind event handlers so they are only bound once per instance.
    this._onKeyboardShortcut = this._onKeyboardShortcut.bind(this);
  }

  /**
   * Registers the keyboard shortcut that toggles the audio muting.
   *
   * @inheritdoc
   * @returns {void}
   */
  componentDidMount() {
    this.props.dispatch(
      registerShortcut({
        character: 'K',
        helpDescription: 'keyboardShortcuts.knock',
        handler: this._onKeyboardShortcut
      })
    );
  }

  /**
   * Unregisters the keyboard shortcut that toggles the audio muting.
   *
   * @inheritdoc
   * @returns {void}
   */
  componentWillUnmount() {
    this.props.dispatch(unregisterShortcut('K'));
  }

  /**
   * Creates an analytics keyboard shortcut event and dispatches an action to
   * toggle the audio muting.
   *
   * @private
   * @returns {void}
   */
  _onKeyboardShortcut() {
    // Ignore keyboard shortcuts if the audio button is disabled.
    if (this._isDisabled()) {
      return;
    }

    AbstractButton.prototype._onClick.call(this);
  }

  /**
   * Handles clicking / pressing the button, and opens a new window with the user documentation.
   *
   * @private
   * @returns {void}
   */
  _handleClick() {
    this.props.dispatch(sendMultiKnockMessage());
  }
}

/**
 * Maps part of the redux state to the component's props.
 *
 * @param {Object} state - The redux store/state.
 * @returns {Object}
 */
function _mapStateToProps(state) {
  // const enabled = getFeatureFlag(state, HELP_BUTTON_ENABLED, true);
  // const visible = typeof userDocumentationURL === 'string' && enabled;

  return {
    visible: true,
    _userIdleMode: state['features/settings'].userIdleMode
  };
}

KnockButton.propTypes = {
  /**
   * The URL to the user documentation.
   */
  _userDocumentationURL: PropTypes.string,
  participantId: PropTypes.string,
  showLabel: PropTypes.bool
};

export default React.memo(
  translate(connect(_mapStateToProps)(withBoundary(KnockButton)))
);
